import { render, staticRenderFns } from "./KpiRemarksPopup.vue?vue&type=template&id=52b0f8e7&scoped=true&"
import script from "./KpiRemarksPopup.vue?vue&type=script&lang=ts&"
export * from "./KpiRemarksPopup.vue?vue&type=script&lang=ts&"
import style0 from "./KpiRemarksPopup.vue?vue&type=style&index=0&id=52b0f8e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0f8e7",
  null
  
)

export default component.exports